import { Component, Input } from '@angular/core';

interface UserCard {
  title: string;
  description: string;
  image: string;
  buttonText: string;
  buttonLink: string;
  hasDropdown?: boolean;
  dropdownItems?: DropdownItem[];
}

interface DropdownItem {
  label: string;
  link: string;
}

@Component({
  selector: 'app-user-cards',
  templateUrl: './user-cards.component.html',
  styleUrls: ['./user-cards.component.scss'],
  standalone: false,
})
export class UserCardsComponent {
  @Input() cards: UserCard[] = [
    {
      title: 'Instructors',
      description: 'Explore powerful instructor tools and resources for your discipline.',
      image:
        'https://prod-cat-files.macmillan.cloud/MediaResources/instructorcatalog/college/common/callouts-homepage/instructor-thumbnail.jpg',
      buttonText: 'Browse by Discipline',
      buttonLink: '#',
      hasDropdown: true,
      dropdownItems: [
        {
          label: 'Astronomy',
          link: 'https://www.macmillanlearning.com/college/us/discipline/Astronomy',
        },
        {
          label: 'Biochemistry',
          link: 'https://www.macmillanlearning.com/college/us/discipline/Biochemistry',
        },
        {
          label: 'Biology',
          link: 'https://www.macmillanlearning.com/college/us/discipline/Biology',
        },
        {
          label: 'Chemistry',
          link: 'https://www.macmillanlearning.com/college/us/discipline/Chemistry',
        },
        {
          label: 'College Success',
          link: 'https://www.macmillanlearning.com/college/us/discipline/College%20Success',
        },
        {
          label: 'Communication',
          link: 'https://www.macmillanlearning.com/college/us/discipline/Communication',
        },
        {
          label: 'Economics',
          link: 'https://www.macmillanlearning.com/college/us/discipline/Economics',
        },
        {
          label: 'English',
          link: 'https://www.macmillanlearning.com/college/us/discipline/English',
        },
        {
          label: 'Environmental Science',
          link: 'https://www.macmillanlearning.com/college/us/discipline/Environmental%20Science',
        },
        {
          label: 'Geography',
          link: 'https://www.macmillanlearning.com/college/us/discipline/Geography',
        },
        {
          label: 'Geology',
          link: 'https://www.macmillanlearning.com/college/us/discipline/Geology',
        },
        {
          label: 'History',
          link: 'https://www.macmillanlearning.com/college/us/discipline/History',
        },
        {
          label: 'Mathematics',
          link: 'https://www.macmillanlearning.com/college/us/discipline/Mathematics',
        },
        {
          label: 'Nutrition and Health',
          link: 'https://www.macmillanlearning.com/college/us/discipline/Nutrition%20and%20Health',
        },
        {
          label: 'Physics',
          link: 'https://www.macmillanlearning.com/college/us/discipline/Physics',
        },
        {
          label: 'Psychology',
          link: 'https://www.macmillanlearning.com/college/us/discipline/Psychology',
        },
        {
          label: 'Sociology',
          link: 'https://www.macmillanlearning.com/college/us/discipline/Sociology',
        },
        {
          label: 'Statistics',
          link: 'https://www.macmillanlearning.com/college/us/discipline/Statistics',
        },
      ],
    },
    {
      title: 'Students',
      description: 'Resources and tools to support your unique learning journey.',
      image:
        'https://prod-cat-files.macmillan.cloud/MediaResources/instructorcatalog/college/common/callouts-homepage/student-thumbnail.jpg',
      buttonText: 'Student Store',
      buttonLink: 'https://store.macmillanlearning.com/us',
      hasDropdown: false,
    },
    {
      title: 'Achieve',
      description: 'Sign in or set up an Achieve account.',
      image:
        'https://prod-cat-files.macmillan.cloud/MediaResources/instructorcatalog/college/common/callouts-homepage/wave-icon.png',
      buttonText: 'Sign into Achieve',
      buttonLink: 'https://achieve.macmillanlearning.com/start',
      hasDropdown: false,
    },
  ];

  dropdownOpen = false;

  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }
}
